import { render, staticRenderFns } from "./ExtratoClienteDadosDevolucao.vue?vue&type=template&id=dd57117c&scoped=true&"
import script from "./ExtratoClienteDadosDevolucao.vue?vue&type=script&lang=js&"
export * from "./ExtratoClienteDadosDevolucao.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoClienteDadosDevolucao.vue?vue&type=style&index=0&id=dd57117c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd57117c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
